import NewOpportunities from './NewOpportunities'

export default NewOpportunities;